import { render } from "./Resume.vue?vue&type=template&id=4e506504&scoped=true"
import script from "./Resume.vue?vue&type=script&lang=js"
export * from "./Resume.vue?vue&type=script&lang=js"

import "./Resume.vue?vue&type=style&index=0&id=4e506504&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4e506504"

export default script